import styled from "styled-components";
import Table from "../../components/Table";

const Tab1 = () => {
  const data = [
    { rank: "1", reward: "6700" },
    { rank: "2~3", reward: "5700" },
    { rank: "4~10", reward: "4700" },
    { rank: "11~100", reward: "3700" },
  ];

  const data2 = [
    {
      rank: "1",
      reward:
        "1000元金山一卡通、光环·少年英雄（永久绑定，无有效期）、龙战于野·剑耀（30天，不绑定）*1、凡品心灵感悟（永久绑定）*1",
    },
    {
      rank: "2~3",
      reward:
        "光环·锋芒初露（永久绑定，无有效期 ）、龙战于野·剑耀（30天，不绑定）*1、凡品心灵感悟（永久绑定）*1",
    },
    { rank: "4~10", reward: "凡品心灵感悟（永久绑定）*1" },
  ];
  return (
    <TabContainer>
      <p>
        <span className="bold">活动区服</span>：
        <span>龙盘紫霄（2010区新服）</span>
      </p>
      <p>
        <span className="bold">活动时间</span>：3月15日开服后-4月21日 24：00
      </p>
      <p>
        前十领奖时间：<span>4月22日（更新成绩后）- 4月28日24：00</span>
      </p>
      <p>相关NPC：江湖接引使</p>
      <p> <span className="bold">活动内容</span>：</p>
      <p>
        （1）活动期间，大侠达到<span>100级</span>
        时，可于江湖接引使处领取<span>一份等级经验礼，直升120级！</span>
      </p>
      <p>
        （2）活动期间，大侠达到<span>152级、155级、157级、160级</span>
        时候，均可领取一份等级好礼，此外，达到以下条件，将额外获得剑侠币等奖励
      </p>
      <p>①区服前600个达到152级</p>
      <p>②区服前500个达到155级</p>
      <p>③区服前300个达到157级</p>
      <p>④区服前200个达到160级</p>
      <p>
        （3）活动期间，大侠每获得一点额外技能点、每获得一点额外潜能点、150技能等级每提升至一个更高等级、战技每提升至一个更高等级将可获得一定的少年英雄积分。
      </p>
      <p>
        （4）活动结束时（4月21日24；00），根据角色经验排名，排名前十的大侠将获得额外的一定的少年英雄积分。
      </p>
      <Table
        columns={[
          { title: "新服宝藏", key: "rank", width: "50%" },
          { title: "奖励积分", key: "reward", width: "50%" },
        ]}
        data={data}
      />
      <p>
        （5）活动结束时，将根据大侠的少年英雄积分进行排名，排名前十的大侠将获得丰厚的奖励。
      </p>

      <p className="bold">活动奖励</p>
      <Table
        columns={[
          { title: "积分排名", key: "rank", width: "30%" },
          { title: "奖励道具", key: "reward", width: "70%" },
        ]}
        data={data2}
      />
    </TabContainer>
  );
};

export const TabContainer = styled.div`
  p {
    &.bold {
      font-weight: 400;
    }
    span:not(.bold):not(.link) {
      color: #cd5629;
    }
  }
  p.bold,
  p > .bold {
    font-weight: bold;
  }
  img {
    width: 17.75rem;
    margin-top: 1rem;
  }
  h3 {
    font-family: "思源宋体";
    margin-block: 10px;
  }
  span.link {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }
`;
export default Tab1;
